import {isLeft} from 'fp-ts/lib/Either'
import {analyticsEventToProfileField} from '../common/analytics/transform'
import {
  CustomUserProfileFields,
  CustomUserProfileFieldsCodec
} from '../common/types'

export const getCustomUserFields = (
  preferences: unknown
): CustomUserProfileFields => {
  if (typeof preferences !== 'object' || !preferences) {
    return []
  }

  const result = CustomUserProfileFieldsCodec.decode(
    // @ts-ignore yes I know 'customUserProfileFields' does not exist on type 'object'
    preferences.customUserProfileFields
  )
  if (isLeft(result)) {
    return []
  }

  return result.right
}

export const getCustomEventFields = (
  customEventConfig?: {id: string; name: string}[]
): CustomUserProfileFields => {
  if (!customEventConfig) {
    return []
  }

  return customEventConfig.flatMap(
    event => [
      {
        name: analyticsEventToProfileField(event.name, 'first')
      },
      {
        name: analyticsEventToProfileField(event.name, 'last')
      }
      // counting disabled until further fleshed out
      // {
      //   name: countAtAnalyticsFieldName(event.name)
      // }
    ],
    []
  )
}
